import { baseApi } from "../baseApi";

export const AssemblyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkOrderList: builder.query({
      query: (data) => ({
        url: `/api/resource/Work Order`,
        params: {
          fields: '["production_item","name","creation","status"]',
          limit_start:data.page,
          limit_page_length:data.pageSize,
          order_by: "`tabWork Order`.`modified` desc"
        },
      }),
      keepUnusedDataFor: 0,
      providesTags: [],
    }),
    getWorkOrderDetail: builder.query({
      query: (data) => ({
        url: `/api/resource/Work Order/${data}`
      }),
      keepUnusedDataFor: 0,
      providesTags: [],
    }),
    getWorkOrderItemList: builder.query({
      query: (data) => ({
        url: `/api/resource/Item`,
        params: {
          filters: `[["is_stock_item","=",1],["item_code","like","%${data}%"]]`,
        },
      }),
      keepUnusedDataFor: 0,
      providesTags: [],
    }),
    getWorkOrderBomList: builder.query({
      query: (data) => ({
        url: `/api/resource/BOM`,
        params: {
      filters: JSON.stringify([
        ["item", "=", data],
        ["docstatus", "=", 1]
      ]),
      limit_page_length: 999999,
      order_by: "creation desc"
       },
      }),
    }),
    getWorkOrderWithCollection: builder.query({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_all_connections_work_order`,
        params: {work_order_name: data},
      }),
      providesTags: ['workorder']
    }),
    PostAssemblyList: builder.mutation({
      query: () => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_assembly_order_list`,
        method:'post'
      })
    }),
    PostCreateAssembly: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.create_work_order`,
        method:'post',
        body:data
      })
    }),
    PostSubmitAssembly: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_work_order`,
        method:'post',
        body:data
      })
    }),
    PostAssemblyPickList: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.create_work_order_picklist`,
        method:'post',
        body:data
      })
    }),
    PostUpdateAssemblyPick: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.update_pick_list_work_order`,
        method:'post',
        body:data
      })
    }),
    PostSubmitAssemblyPick: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.submit_work_order_picklist`,
        method:'post',
        body:data
      })
    }),
    PostFinalStockAssembly: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.make_final_stock_entry_wo`,
        method:'post',
        body:data
      }),
      invalidatesTags: ['workorder']
    }),
    PostStockEntryAssembly: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_stock_entry`,
        method:'post',
        body:data
      }),
      invalidatesTags: ['workorder']
    }),
    getPickDetail: builder.query({
      query: (data) => ({
        url: `/api/resource/Pick List/${data}`
      }),
    }),
  }),
});

export const {  usePostStockEntryAssemblyMutation,usePostFinalStockAssemblyMutation,useGetWorkOrderWithCollectionQuery,usePostUpdateAssemblyPickMutation,useGetPickDetailQuery,usePostAssemblyListMutation,useGetWorkOrderListQuery,useGetWorkOrderItemListQuery,useGetWorkOrderBomListQuery,usePostCreateAssemblyMutation,useGetWorkOrderDetailQuery,usePostSubmitAssemblyMutation,usePostAssemblyPickListMutation,usePostSubmitAssemblyPickMutation } = AssemblyApi;
